import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { endOfDay } from "date-fns";
import servicesUtils from "../../../utils/servicesUtils";
var getEncounters = function getEncounters(workspaceId, patientId, page, props) {
  var _props$statusFilter;
  var params = {};
  var _ref = props.dateFilter || [],
    _ref2 = _slicedToArray(_ref, 2),
    start = _ref2[0],
    end = _ref2[1];
  if (start && end) {
    var startDate = new Date(start);
    var endDate = new Date(end);
    if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
      // Start: start of day (local) as UTC ISO; end: end of day (local) as UTC ISO
      params.start_date = startDate.toISOString();
      params.end_date = endOfDay(endDate).toISOString();
    }
  }
  if (props !== null && props !== void 0 && (_props$statusFilter = props.statusFilter) !== null && _props$statusFilter !== void 0 && _props$statusFilter.value) {
    params.status = props.statusFilter.value;
  }
  return servicesUtils.getService("/emr/workspaces/".concat(workspaceId, "/patients/").concat(patientId, "/encounters/?page=").concat(page), params);
};
export default getEncounters;